import { Button, Dropdown } from "react-bootstrap";
import "./patientsmaterprofileheader.scss";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import { ReactSVG } from "react-svg";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../utils/permissionUtils";

const PatientsMaterProfileHeader = ({ title, id, toggleModal }: any) => {

  const isPermitted = useModulePermissions(PermissionModule.PATIENT_MASTER);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_PATIENT_MASTER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_PATIENT_MASTER);

  return (
    <div className="patients-master-profile-header-wrapper">
      <div className="profile-title-status-box">
        <h2>{title}</h2>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href={`/edit-patient/${id}`}>
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        {isDeletePermitted && (
          <Dropdown>
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={toggleModal}>
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default PatientsMaterProfileHeader;
